import styled from 'styled-components/macro'

/** Styled Components */

export const Textarea = styled.textarea.attrs(() => ({
    required: true,
}))`
    width: 100%;
    float: left;
    padding: ${props =>
        props.primary ? '24px 12px 8px 32px' : '24px 12px 8px 12px'};
    border: 1px solid #b9b9b9;
    border-radius: 6px;
    background: #fff;
    height: 48px;
    font-size: 12px;
    font-family: 'Gordita-Regular';
    color: #000000;
    box-sizing: border-box;

    :hover {
        background: #ffffff 0% 0% no-repeat padding-box;
        border: 1px solid #eb974e;
        box-shadow: 0px 3px 6px #00000029;
    }
`
export const Input = styled.input.attrs(() => ({
    required: true,
}))`
    width: 100%;
    float: left;
    padding: ${props =>
        props.primary ? '26px 12px 6px 42px' : '26px 12px 6px 12px'};
    border: 1px solid #b9b9b9;
    border-radius: 6px;
    background: #fff;
    height: 48px;
    font-size: 12px;
    font-family: 'Gordita-Regular';
    color: #000000;
    outline: 0;
    box-sizing: border-box;

    :hover {
        background: #ffffff 0% 0% no-repeat padding-box;
        border: 1px solid #eb974e;
        box-shadow: 0px 3px 6px #00000029;
    }

    ${({ activeDropdown }) =>
        activeDropdown &&
        `
        border: 1px solid #EB974E;

`}
`
export const InputContent = styled.div`
    color: #999;
    font-size: 12px;
    font-family: 'Gordita-Regular';
    position: absolute;
    pointer-events: none;
    left: ${props => (props.primary ? '42px' : '12px')};
    top: 18px;
    transition: 0.26s ease-in;
    ${Input}:focus ~ &,
    ${Input}:not(:placeholder-shown).input:not(:focus) ~ label,
    ${Input}[readonly="true"]:focus + &,
    ${Input}:valid ~ & {
        top: 10px;
        font-size: 10px;
        transition: 0.26s ease-out;
        line-height: 10px;
    }
    ${Textarea}:focus ~ &,
    ${Textarea}:not(:placeholder-shown).input:not(:focus) ~ label,
    ${Textarea}:valid ~ & {
        top: 1px;
        font-size: 10px;
        transition: 0.26s ease-out;
        line-height: 10px;
        background: #fff;
        width: 95%;
        text-align: left;
        height: 24px;
        padding-top: 8px;
    }
    ${Input}:focus ~ & span,
    ${Input}:valid ~ & span{
        left: 50px;
        bottom: -2px;
    }
    ${Input}:focus ~ & span svg{
        width: 10px; 
        height: 10px;
    }
    
`

export const CancelButton = styled.span`
    width: 18px;
    height: 18px;
    position: absolute;
    right: 12px;
    top: 8px;
    display: none;

    svg {
        width: 18px;
        height: 18px;
    }
`

export const ErrorMessage = styled.div`
    font-size: 9px;
    font-weight: normal;
    font-family: 'Gordita-Regular';
    margin-bottom: 0px;
    color: #fc2a2a;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    position: absolute;
    top: -13px;
    line-height: 12px;
`

export const InputErrorIcon = styled.span`
    width: 10px;
    height: 10px;
    position: absolute;
    right: 12px;
    top: 19px;

    svg {
        width: 10px;
        height: 10px;
        position: absolute;
    }
`
export const InputWrapper = styled.div`
    width: 100%;
    float: left;
    position: relative;
    label {
        width: 24px;
        height: 24px;
        margin: 0px;
        position: absolute;
        right: 20px;
        top: 21px;

        svg {
            width: 24px;
            height: 24px;
        }
    }
`
export const DropdownLi = styled.div`
    width: 100%;
    float: left;
    display: inline-flex;
    align-items: center;
    border-bottom: 1px solid #b6b6b6;
    font-size: 12px;
    font-family: 'Gordita-Regular';
    height: 36px;
    padding: 0 10px;
    background: #fff;
    cursor: pointer !important;
    color: #000;

    .fflag {
        margin-right: 7px;
    }

    :first-child {
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        background: #fff;
    }
    :last-child {
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
        background: #fff;
        border-bottom: 0.5px solid #fff;
    }
    :hover {
        background: #ffe5d3;
        color: #333;
        border-bottom: 1px solid #ffe5d3;
        .option-input.radio {
            border: 1px solid #2468f6;
        }
    }
    // span {
    //     position: relative;
    //     top: 2px;
    // }
    ${({ highlight }) =>
        highlight &&
        `    background: #ffe5d3;
               color: #333;
               border-bottom: 1px solid #ffe5d3;
           
            `}

    .country_code_dropdown{
        display: flex;
        align-items: center;
        span:nth-child(1){
            font-size: 18px;
        }
        span:nth-child(2){
            font-size: 12px;
            margin-left: 6px;
        }
        span:last-child{
            margin-left: 5px;
            margin-top: 2px;
        }
    }
`
export const DropdownUl = styled.div`
    width: 100%;
    position: ${props => (props.relative ? 'relative' : 'absolute')};
    margin-top: 0px;
    right: 0px;
    left: 0%;
    cursor: pointer;
    padding: 0px;
    overflow-y: scroll;
    max-height: 212px;
    margin-bottom: 0px;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 6px;
    z-index: 2;
    margin-bottom: 0px;
`
export const RightDropdownArrow = styled.div`
    width: 10px;
    height: 10px;
    position: absolute;
    right: 12px;
    top: 20px;
    cursor: pointer;

    svg {
        width: 10px;
        height: 10px;
        transform: rotate(90deg);
        color: #000000;
        position: absolute;
        fill: #000000;
    }
`
export const IconRight = styled.span`
    width: 16px;
    height: 16px;
    position: absolute;
    right: 12px;
    top: 17px;

    svg {
        color: rgb(85, 85, 85);
        fill: rgb(85, 85, 85);
        width: 16px;
        height: 16px;
        position: absolute;
    }
`
export const InputContainer = styled.div`
    width: 100%;
    float: left;
    position: relative;
    margin-bottom: 20px;

    .display_dialCode{
        width: 100%;
        float: left;
        padding: 25px 12px 6px 10px;
        border-left: 1px solid #b9b9b9;
        border-top: 1px solid #b9b9b9;
        border-bottom: 1px solid #b9b9b9;
        border-radius: 6px 0 0 6px;
        background: #fff;
        height: 48px;
        // font-size: 12px;
        font-family: 'Gordita-Regular';
        color: #000000;
        outline: 0;
        box-sizing: border-box;
        background: #f2f2f2;
        display: flex;
        align-items: center;

        span:last-child{
            padding-left: 5px;
            font-size: 12px;
        }

        :hover {
            background: #ffffff 0% 0% no-repeat padding-box;
            border: 1px solid #eb974e;
            box-shadow: 0px 3px 6px #00000029;
        }
    }

    .display_country{
        width: 100%;
        float: left;
        padding: 25px 12px 6px 42px;
        border: 1px solid #b9b9b9;
        border-radius: 6px;
        background: #fff;
        height: 48px;
        display: flex;
        align-items: center;

        span:last-child{
            padding-left: 5px;
            font-size: 12px;
        }
        span:first-child{
            font-size: 16px;
        }

        :hover {
            background: #ffffff 0% 0% no-repeat padding-box;
            border: 1px solid #eb974e;
            box-shadow: 0px 3px 6px #00000029;
        }
    }
`
export const DropdownUlWrapper = styled.div`
    width: 100%;
    float: left;
    position: relative;
    margin-bottom: 0px;
   
    .country_code{
        width: 320px;
        @media (min-width: 2160px) {
            width: 580px;
        }
        @media (min-width: 1920px) {
            width: 430px;
        }
        @media (max-width: 1700px) {
            width: 369px;
        }
        @media (max-width: 1440px) {
            width: 307px;
        }
        @media (max-width: 1368px) {
            width: 286px;
        }
        @media (max-width: 1280px) {
            width: 265px;
        }
    }
`
export const DropdownWrapper = styled.div`
    width: 100%;
    float: left;
    ${InputContainer} {
        ${Input} {
            //   padding-right: 40px;
            :hover {
                :hover {
                    outline: 0;
                    border: 1px solid #eb974e;
                    box-shadow: 0px 3px 6px #00000029;
                }
                :focus {
                    background: #ffffff 0% 0% no-repeat padding-box;
                    border: 1px solid #b9b9b9;
                    box-shadow: none;
                }
                :active {
                    background: #ffffff 0% 0% no-repeat padding-box;
                    border: 1px solid #b9b9b9;
                    box-shadow: none;
                }
            }
        }
        ${CancelButton} {
            width: 24px;
            height: 24px;
            display: flex;
            left: 12px;
            top: 12px;
            svg {
                width: 24px;
                height: 24px;
                color: #ccc;
                fill: #ccc;
            }
        }
    }
`
export const WorkspaceName = styled.div`
    width: 100%;
    float: left;
    display: grid;
    grid-template-columns: 50% 50%;

    .workspace_input {
        background: #f2f2f2 0% 0% no-repeat padding-box;
        border: 1px solid #b9b9b9;
        border-radius: 6px 0px 0px 6px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: left;
        width: 100%;
        float: left;
        font-size: 12px;
        text-align: left;
        font-family: Gordita-Regular;
        color: #000000;
        font-weight: 500;
        padding: 0px 12px;
        border-right: none;

        label {
            position: relative;
            top: 1px;
            margin-bottom: 0px;
            max-width: 85%;
            white-space: pre-wrap;
            word-wrap: break-word;
        }
    }

    ${Input} {
        border-radius: 0px 6px 6px 0px;
    }
    ${ErrorMessage} {
        width: max-content;
        right: 6px;
    }
`
export const PasswordIcon = styled.div`
    width: 16px;
    height: 16px;
    position: absolute;
    right: 12px;
    top: 17px;

    svg {
        width: 16px;
        height: 16px;
        position: absolute;
        right: 13px;
    }
`
export const InformationIcon = styled.div`
position: relative;
    span{
        width: 14px;
        height: 14px;
        position: absolute;
        left: 60px;
        bottom: 6px;
        color: #999;
        transition: 0.26s ease-out;
        cursor: pointer;
    }
    svg {
        width: 10px;
        height: 10px;
        pointer-events: all;
        transition: 0.26s ease-out;
    }

    [tooltip]::after{
        bottom: 25px;
        left: 20px;
        color: #000;
        font-size: 11px; 
        width: 250px;
    }
    [tooltip]::before{
        border: solid;
        border-color: rgb(255 255 255) transparent;;
        border-width: 15px 7px 0 7px;
        left: 6px;
        bottom: 10px;
    }

`
export const PasswordWrapper = styled.div`
    width: 100%;
    float: left;
    position: relative;
`
export const WidthContainer = styled.div`
    width: 100%;
    float: left;
    display: grid;
    grid-template-columns: 48.3% 48.3%;
    grid-gap: 20px;
    margin-bottom: 20px;

    @media (min-width: 320px) and (max-width: 600px) {
        grid-template-columns: 99.6%;
    }
    :last-child {
        margin-bottom: 0px;
    }
    ${DropdownUlWrapper} {
        margin-bottom: 0px;
    }
    ${InputContainer} {
        margin-bottom: 0px;
    }
`
export const MobileWrapperLeft = styled.div`
    ${DropdownWrapper} {
        width: 90px;
    }
    img {
        width: 32px;
        height: 20px;
        margin-right: 7px;
        top: 2px;
        position: relative;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    ${Input} {
        padding-left: 12px;
        background: #f2f2f2 0% 0% no-repeat padding-box;
        border: 1px solid #b9b9b9;
        border-radius: 6px 0px 0px 6px !important;
        border-right: none;
        padding-right: 12px;
    }
    ${InputContent} {
        left: 12px;
    }
    ${DropdownLi} {
        img {
            top: 0px;
        }
    }
`
export const MobileWrapper = styled.div`
    width: 100%;
    float: left;
    display: flex;
    ${Input} {
        border-radius: 0px 6px 6px 0px;
    }
`

export const MobileCodeWrapper = styled.div`
    width: 100%;
    float: left;
    display: grid;
    grid-template-columns: 48.3% 48.3%;
    grid-gap: 20px;
`
export const Paragraph = styled.p`
    width: 100%;
    float: left;
    font-family: Gordita-Regular;
    font-size: 14px;
    color: rgb(0, 0, 0);
    border-bottom: 1px solid #a0a9cb;
    padding-bottom: 15px;
    margin-bottom: 20px;
    margin-top: 0px;
    @media (max-width: 520px) {
    font-size: 10px !important;
    padding-bottom:10px;
    margin-bottom:5px  !important;
    line-height:1.7;
    }
`
export const Button = styled.button`
    min-width: 90px;
    height: 32px;
    background: ${props => (props.primary ? '#fff' : '#2468f6')};
    border-radius: 18px;
    border: ${props =>
        props.primary ? '1px solid #b9b9b9' : '1px solid #2468f6'};
    outline: 0;
    font-size: 12px;
    padding: 7px 12px;
    font-family: 'Gordita-Medium';
    color: ${props => (props.primary ? '#333' : '#fff')};
    margin: 10px 0px;
    cursor: pointer;

    :hover {
        background: #ffe5d3;
        color: #333;
        border: 1px solid #ffe5d3;
    }
    :active {
        background: ${props => (props.primary ? '#fff' : '#2468f6')};
        border: ${props =>
            props.primary ? '1px solid #b9b9b9' : '1px solid #2468f6'};
        color: ${props => (props.primary ? '#333' : '#fff')};
    }
    :focus {
        background: #ffe5d3;
        color: #333;
        border: 1px solid #eb974e;
    }

    span {
        width: 12px;
        height: 12px;
        float: left;
        margin-right: 6px;
        display: flex;
        align-items: center;
        position: relative;
        top: 0px;
        cursor: pointer;
        svg {
            width: 12px;
            height: 12px;
            fill: #333;
            color: #333;
            margin-right: 0px;
        }
    }
    label {
        margin-bottom: 0px;
        position: relative;
        top: 1px;
        cursor: pointer;
    }
`
export const SignInWrapper = styled.div`
    width: 100%;
    float: left;
    display: flex;
    align-items: center;
    justify-content: space-between;

    ${Button} {
        margin: 0px;
        float: left;
    }
    ${Paragraph} {
        float: right;
        width: auto;
        padding: 0px;
        position: relative;
        top: 1px;
        span {
            color: #2468f6;
            text-decoration: none;
            cursor: pointer;
            :hover {
                text-decoration: underline;
            }
        }
    }
    @media (max-width: 520px) {
        flex-direction:column;
    ${Button} {
        width:100%;
    }
    ${Paragraph}{
        align-self: flex-start;
        padding-top: 10px;
        margin-top: 5px !important;
        font-size: 10px !important;
        line-height:1.7;
    }
}
`
export const PopupLoader = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    animation-name: spin;
    animation-duration: 3s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    img {
        width: 64px;
        height: 64px;
    }
    @-ms-keyframes spin {
        from {
            -ms-transform: rotate(0deg);
        }
        to {
            -ms-transform: rotate(360deg);
        }
    }
    @-moz-keyframes spin {
        from {
            -moz-transform: rotate(0deg);
        }
        to {
            -moz-transform: rotate(360deg);
        }
    }
    @-webkit-keyframes spin {
        from {
            -webkit-transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(360deg);
        }
    }
    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
`
export const FormWrapper = styled.form`
    width: 100%;
    float: left;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 30px #0000001a;
    border-radius: 20px;
    padding: 30px;
    align-self: baseline;
    @media (min-width: 320px) and (max-width: 600px) {
    }

    ${Paragraph} {
        border: none;
        margin: 0;
        font-size: 12px;
        color: #000000;

        a {
            color: #2468f6;
            text-decoration: none;
            :hover {
                text-decoration: underline;
            }
        }
    }
`
export const HeaderContent = styled.h1`
    width: 100%;
    float: left;
    font-size: 24px;
    font-family: Gordita-Medium;
    color: rgb(0, 0, 0);
    margin-bottom: 12px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    line-height: 24px;
    font-weight: 500;
    top: 113px;
`
export const ChannelIcons = styled.div`
    width: auto;
    float: right;
    margin-left: 10px;
    ._display_icons {
        position: relative;
        :nth-child(1) {
            .hover_content {
                transform: translateX(0%);
            }
        }
        :nth-child(2) {
            .hover_content {
                transform: translateX(-17%);
            }
        }
        :nth-child(3) {
            .hover_content {
                transform: translateX(-23%);
            }
        }

        .hover_content {
            position: absolute;
            width: max-content;
            background: #fff;
            z-index: 1;
            font-size: 12px;
            line-height: normal;
            padding: 5px 8px 0px 8px;
            border-radius: 6px;
            box-shadow: 0px 3px 6px #00000029;
            top: -26px;
            left: -50%;
            display: none;
            font-family: 'Gordita-Regular';
            color: #476b95;
            margin: 0;
        }
        :hover {
            .hover_content {
                display: block;
            }
        }
    }
`
export const LiContent = styled.li`
    width: 100%;
    float: left;
    font-family: Gordita-Regular;
    font-size: 14px;
    color: rgb(0, 0, 0);
    margin-bottom: 18px;
    margin-top: 0px;
    list-style: none;
    display: flex;
    align-items: center;
    @media (max-width: 520px) {
        font-size: 13px; 
    }

    label {
        position: relative;
        top: 1px;
        margin: 0;
    }
    span {
        width: 24px;
        height: 24px;
        margin-right: 12px;
        float: left;
        @media (max-width: 520px) {
         width: 20px;
         height: 20px;
        }
        svg {
            width: 24px;
            height: 24px;
        @media (max-width: 520px) {
         width: 20px;
         height: 20px;
        }
     }
    }
`
export const UlWrapper = styled.ul`
    width: 100%;
    float: left;
    padding: 0px;
    margin: 0px;
    ${HeaderContent} {
        font-size: 16px;
        line-height: 18px;
        margin-bottom: 20px;
    @media(max-width:520px){
            font-size: 15px;
     }
    }
`
export const MobileContentWrapper = styled.div`
    width: 100%;
    padding: 0px 20px 20px 20px;
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    padding-top: 0px;
`
export const MobileHeaderContentWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-top: 0px;
    padding-left: 13px;
    @media(max-width:520px){
       margin-top:50px;
   }
`

export const ContentWrapper = styled.div`
    width: 100%;
    float: left;
    display: flex;
    flex-direction: column;
    padding-top: 0px;
    .img_wrapper {
        width: 100%;
        float: left;
        border-top: 1px solid #a0a9cb;
        padding-top: 20px;
        /* img {
            width: 310px;
            height: 260px;
        } */
    }
`
export const GridContainer = styled.div`
    width: 100%;
    float: left;
    display: grid;
    grid-template-columns: 390px 53.5%;
    padding-left: 68px;
    padding-right: 68px;
    grid-gap: 200px;
    justify-content: space-between;
    position: relative;
    margin-top:25px;
    align-items: center;

    @media (max-width: 1600px) {
        height: auto;
        align-items: flex-start;
       
    }
    @media (max-width: 1340px) {
        grid-gap:150px;
    }
    @media (max-width: 1024px) {
        grid-gap:50px;
    }


    .bottom_img_wrapper {
        width: 100%;
        float: left;
        padding-top: 40px;

        h4 {
            width: 100%;
            float: left;
            font-size: 24px;
            font-family: Gordita-Medium;
            color: rgb(0, 0, 0);
            margin-bottom: 18px;
            text-align: center;
        }
    }
`

export const GridContainerMobile = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    justify-content: space-between;
    position: relative;
    height: calc(100vh - 100px);
    align-items: center;

    @media (max-width: 1600px) {
        height: 100%;
        align-items: flex-start;
    }

    ${HeaderContent} {
        padding-top: 2px;
    }
    ${Paragraph} {
        border-bottom: none;
        font-size: 14px;
        margin-bottom: 5px;
    }
    ${FormWrapper} {
        border-radius: 0px;
        padding: 20px;
        ${Paragraph} {
            font-size: 9px;
        }
        ${Button} {
            min-width: 143px;
        }
    }
    ${UlWrapper} {
        border-bottom: 1px solid #a0a9cb;
    }

    .bottom_img_wrapper {
        width: 100%;
        float: left;
        padding-top: 40px;
    }
`

export const Logo = styled.img`
    width: max-content;
    height: 38px;
    float: left;
    padding-left: 68px;

    @media (min-width: 320px) and (max-width: 600px) {
        display: inline-block;
        position: relative;
        width: 296px;
        height: 38px;
        opacity: 1;
        float: left;
        padding: 0;
        top: 14px;
        left: 12px;
    }
`
export const ImageWrapper = styled.header`
    width: 100%;
    float: left;
    padding-top: 20px;
    
`
export const BgImage = styled.img`
    width: 100%;
    height: 100vh;
    position: absolute;
    z-index: -1;
`
export const Wrapper = styled.section`
    width: 100%;
    float: left;
    height: 100vh;
    position: relative;
    padding: 0px;

    @media (min-width: 320px) and (max-width: 600px) {
        display: inline-block;
        // width: 428;
        /* height: 1760px; */
        background: url('https://s3.ap-south-1.amazonaws.com/web.workativ/signup_bg.png')
            no-repeat;
        opacity: 1;
        background-size: cover;
        background-position: center;
        position: fixed;
        margin: 0px 0px 0px 0px;
        padding: 0px;
        overflow-y: scroll;
        overflow-x: hidden;
    }

    ::before {
        position: fixed;
        content: '';
        background: url('https://s3.ap-south-1.amazonaws.com/web.workativ/signup_bg.png')
            no-repeat;
        width: 100%;
        height: 100%;
        background-size: cover;
        z-index: -1;
        background-position: bottom;
    }
`

export const LogosHeader = styled.h4`
    width: 100%;
    float: left;
    font-size: 20px;
    font-family: Gordita-Medium;
    color: rgb(0, 0, 0);
    margin-bottom: 18px;
    text-align: center;

    @media(max-width:520px){
        font-size: 15px;  
    }
`

export const IsoLogo = styled.div`
    width: 100%;
    float: left;
    font-size: 20px;
    font-family: Gordita-Medium;
    color: rgb(0, 0, 0);
    margin-bottom: 18px;
    text-align: center;
    margin-top: 23px;
`

export const MobileOverlay = styled.div`
    height: 100%;
    width: 100vw;
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    left: 0;
    top: 0;
    background-color: rgb(0, 0, 0); /* Black fallback color */
    background-color: rgba(0, 0, 0, 0.7); /* Black w/opacity */
    transition: 0.5s; /* 0.5 second transition effect to slide in or slide down the overlay (height or width, depending on reveal) */
`
export const MobileOverlayContent = styled.div`
    position: relative;
    top: 25%; /* 25% from the top */
    width: 100%; /* 100% width */
    text-align: center; /* Centered text/links */
    margin-top: 30px; /* 30px top margin to avoid conflict with the close button on smaller screens */
    display: flex;
    align-items: center;
    justify-content: center;
`

export const ThankyouWrapper = styled.div`
    width: 95%;
    background-color: white;
    border-radius: 6px;
    min-height: 100px;
    min-width: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${HeaderContent} {
        margin: auto;
        float: none;
        text-align: center;
        display: block;
        margin-top: 20px;
    }

    ${Paragraph} {
        color: #355d8b;
        margin-top: 13px;
        font-size: 16px;
        margin-bottom: 0px;
        padding-bottom: 0px;
    }
`
export const ThankyouImageWrapper = styled.div`
    width: 84px;
    height: 84px;
    margin : auto;
}`

export const ContentWithPadding = styled.div`
    padding: 80px 10%;
`
export const CustomerLogoDiv = styled.div`
   text-align:center;
   padding: 10px 60px 60px;
   float:left;
   width:100%;
   
.heading_customer_logo{
    padding: 20px 0px;
}
   @media(max-width:520px){
       margin-top:30px;
       padding:0px;
   }

`
export const TestimonialsDiv = styled.div`
display:flex;
gap: 26px;
justify-content: center;
float:right;
width:56%;
@media(max-width:1024px){
       width:60%;
   }
   @media(max-width:1440px){
       width:58%;
   }

`
export const FirstReview = styled.div`
display: flex;
align-items: center;
gap: 8px;


           .capterra_logo {
                width:100px;
            }
            .capterra_star_image{
                width:24px;
            }
`
export const SecondReview = styled.div`
display: flex;
align-items: center;
gap: 8px;        
            .g2_logo{
                width:24px;
            }
            .g2_star_image{
                width:24px;
            }
`

export const TestimonialsDivMobile = styled.div`
display:flex;
gap:18px;
align-items:center;
justify-content: flex-start;
padding-bottom: 20px;
@media(max-width:375px){
       gap:8px;
   }

`
export const FirstReviewMobile = styled.div`

align-items:center;
.capterra_logo_mobile{
width:70px;
margin:10px;
}
.capterra_star_mobile{
    width:13px;
    margin: 0px 2px;
}
span{
    font-size:12px;
    margin-left:6px;
}

`
export const SecondReviewMobile = styled.div`

.g2_logo_mobile{
    width:22px;
    margin:10px;
}
.g2_star_mobile{
    width:13px;
    margin: 0px 2px;
}
span{
    font-size:12px;
    margin-left:6px;
}
`